import { render, staticRenderFns } from "./AnnuityRefund.vue?vue&type=template&id=44ca5e1f&scoped=true"
import script from "./AnnuityRefund.vue?vue&type=script&lang=js"
export * from "./AnnuityRefund.vue?vue&type=script&lang=js"
import style0 from "./AnnuityRefund.vue?vue&type=style&index=0&id=44ca5e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca5e1f",
  null
  
)

export default component.exports